<div class="invalidate-confirmation d-flex flex-column justify-content-center align-items-center p-5">
        <small class="text-center">{{data.message}}</small>
        <div class="controls mt-2">
            <div class="d-flex flex-wrap justify-content-center align-items-center action-buttons">
                <button class="mfs-control-button" type="button" (click)="closeDialog({})">{{'others.generalTranslations.cancel' | translate}}</button>
                <button class="mfs-control-button" (click)="confirm()">{{'others.generalTranslations.accept' | translate}}</button>
            </div>
        </div>

</div>